import { FC, ReactNode } from 'react';

import {
  TranscriptContextProvider,
  TranscriptContextProviderProps,
} from '../../store/transcript/store';
import { ChatHeader, ChatHeaderProps } from '../ChatHeader/ChatHeader';
import { MessageInputBox } from '../MessageInputBox/MessageInputBox';
import { Transcript, TranscriptProps } from '../TranscriptBox/Transcript';
import { ChatLayout } from './ChatLayout';

export type ChatInnerProps = ChatHeaderProps &
  TranscriptProps & {
    footer?: ReactNode;
  };

export const ChatInner: FC<ChatInnerProps> = (props) => {

  return (
    <ChatLayout>
      <ChatHeader 
        title={props.title} 
        branding={props.branding} 
        showBetaBadge={props.showBetaBadge}
      />
      <Transcript
        loadingMessage={props.loadingMessage}
        renderMessage={props.renderMessage}
        renderAdditionalActions={props.renderAdditionalActions}
        renderAdditionalMessageUI={props.renderAdditionalMessageUI}
        transcriptFooter={props.transcriptFooter}
      />
      <MessageInputBox />
      {props.footer && props.footer}
    </ChatLayout>
  );
};

export type ChatProps = ChatInnerProps &
  Omit<TranscriptContextProviderProps, 'children'>;

export const Chat: FC<ChatProps> = (props) => {
  return (
    <TranscriptContextProvider {...props}>
      <ChatInner {...props} />
    </TranscriptContextProvider>
  );
};
